module.exports = __webpack_public_path__ + "static/img/radio_tv.9c2f0276.svg";